"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsonrpc_1 = require("@iov/jsonrpc");
const axios_1 = __importDefault(require("axios"));
const xstream_1 = __importDefault(require("xstream"));
class HttpEthereumRpcClient {
    constructor(baseUrl) {
        this.events = xstream_1.default.throw(new Error("Events are not available when connecting via HTTP, use Websockets instead."));
        this.baseUrl = baseUrl;
    }
    async run(request) {
        const result = await axios_1.default.post(this.baseUrl, request);
        return jsonrpc_1.parseJsonRpcResponse(result.data);
    }
    async socketSend() {
        throw new Error("No socket available");
    }
    disconnect() {
        // Not necessary for HTTP
    }
}
exports.HttpEthereumRpcClient = HttpEthereumRpcClient;
//# sourceMappingURL=httpethereumrpcclient.js.map